// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2IAsW","resendInfoText":"OnGoingPaymentBox_resendInfoText__1BjKs"};